function getMessage(field, [max]) {
  return `The ${field} field must be ${max} or less.`
}

function validate(value, [max]) {
  if (Array.isArray(value) || value === null || value === undefined || value === '') {
    return false
  }
  // Remove thousand seperator
  value = '' + value // If a format other den str, it doesnt has replace
  const valueWithoutMask = value.replace(/,/g, '')
  return Number(valueWithoutMask) <= max
}

export default {
  getMessage,
  validate
}
